import { render } from "./Briefs.vue?vue&type=template&id=69514f7b&scoped=true"
import script from "./Briefs.vue?vue&type=script&lang=js"
export * from "./Briefs.vue?vue&type=script&lang=js"

import "./Briefs.vue?vue&type=style&index=0&id=69514f7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69514f7b"]])

export default __exports__